import { Injectable, EventEmitter } from '@angular/core'
import { Observable } from 'rxjs/Observable'

@Injectable()
export class IntroServiceMock {

  public openIntro: EventEmitter<any> = new EventEmitter()
}



// WEBPACK FOOTER //
// ./src/app/shared/services/intro.service.mock.ts